export default __webpack_public_path__ + "static/media/photo2.e9d683c0.jpg";